import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ConnectedContactFlow from '@ignitesales/neuro-application/src/neuro-guide/components/ContactFlow/ConnectedContactFlow';
import { NeuroMessage, useDispatch, triggerIgniteAction } from '@ignitesales/neuro-application';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { notifySuccess } from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';

const ContactFormModal = ({ className, closeBtn, isOpen, onClose, onComplete, email = '', selectedProduct, ...rest }) => {
  const messageContext = useNeuroMessages();
  const dispatch = useDispatch();
  const classes = classnames(className, 'contactFormModal');
  const contactFormHeader = messageContext.getMessage('contactMeForm.header');
  const contactUsMessage = messageContext.getMessage('contactMeForm.contactUs');

  // success form message will live here
  const onEmailSent = ({lead}) => {
    onClose();
    onComplete(lead);
  };

  useEffect(() => {
    isOpen && dispatch(triggerIgniteAction({ actionName: 'contactMeClicked', value: 'started' }));
  }, [isOpen]);

  const fields = [
    {
      name: 'firstName',
      type: 'text',
      required: true
    },{
      name: 'lastName',
      type: 'text',
      required: true
    },{
      name: 'email',
      type: 'text',
      required: true,
      initialValue: email
    },{
      name: 'phone',
      type: 'text',
      required: true
    },
    {
      name: 'workingWithBankerOrBranch',
      type: 'text',
      required: true
    },
    {
      name: 'additionalComments',
      type: 'text',
      required: true
    },
    {
      name: 'preferredMethodOfContact',
      type: 'dropdown',
      options: [{value: '', label: ''}, {value: 'email', label: 'Email'}, {value: 'phone', label: 'Phone'}],
      required: true
    },
  ]

  const fieldsForAnswerService = [
    'workingWithBankerOrBranch',
    'additionalComments',
    'preferredMethodOfContact',
  ]

  return (
    <Modal
      show={isOpen}
      className={classes}
      title={ contactFormHeader }
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >


      <div className="shareResults">
        <NeuroMessage id={ contactUsMessage } tagName='p' />
      </div>

      <ConnectedContactFlow onComplete={onEmailSent} fields={fields} fieldsForAnswerService={fieldsForAnswerService} {...rest} />
    </Modal>
  );
};
ContactFormModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ContactFormModal;
